import _ from 'lodash';
import React from 'react';

import Loader from '../../components/common/loader/Loader';
import Spacer from '../../components/common/spacer/Spacer';
import Gallery from '../../components/derived/gallery/Gallery';
import ErrorScreen from '../../components/derived/error/ErrorScreen';

require('./style.scss');

export default class Photos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photos: null,
      storeName: '',
    };
  }

  render() {
    const profile = this.props.profile;
    const photos = _.map(
      _.filter(profile.images, image => image.image_type === 'store-pic'),
      image => image.image_large);

    let cards = null;
    if (photos === null) {
      cards = <Loader open />;
    } else if (_.size(photos) > 0) {
      cards = (
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-24">
              <Gallery photos={photos} />
            </div>
          </div>
        </div>);
    } else {
      cards = (
        <ErrorScreen
          media={<img role="presentation" src="/static/images/no-Photos.png" />}
          title="Photos are not updated yet"
          helpText={`Stay updated with ${profile.store_name}<br />` +
                    'through m.Paani Shop Smart App'}
        />);
    }

    return (
      <div id="photos-body">
        <Spacer size={2} />

        {cards}
        <Spacer size={2} />
      </div>
    );
  }
}

module.exports = Photos;



// WEBPACK FOOTER //
// ./app/pages/photos/Photos.jsx